import { useCookies } from 'react-cookie';
import useAuthStore from 'store/auth';

const COOKIE_NAME = 'dashboard-questionnaire';

export default function useDashboardQuestionnaire() {
  const profileId = useAuthStore((store) => store.currentUserProfileId);

  const [cookies, setCookie, removeCookie] = useCookies();

  const onHideQuestionnaire = () => {
    const updatedIds = !cookies[COOKIE_NAME]
      ? JSON.stringify([profileId])
      : JSON.stringify([...cookies[COOKIE_NAME], profileId]);
    setCookie(COOKIE_NAME, updatedIds);
  };

  const onClearQuestionnaire = () => removeCookie(COOKIE_NAME);

  const hasDisabled =
    Boolean(cookies[COOKIE_NAME] && cookies[COOKIE_NAME].includes(profileId)) ||
    false;

  return { onHideQuestionnaire, hasDisabled, onClearQuestionnaire };
}
